module.exports = __webpack_public_path__ + "img/pic_egypt_06.c43d34a0.jpg";